import BillingInvoiceService from '@/services/billing_invoice';

export default {
	namespaced: true,
	state: {},

	getters: {},

	actions: {
		async getInvoices({ commit, state, getters, dispatch }) {
			try {
				let response = await BillingInvoiceService.getInvoices();

				return response.data.attributes;
			} catch (e) {
				console.log(e);
			}
		},
		async getInvoicesByCompany({ commit, state, getters, dispatch },id) {
			try {
				let response = await BillingInvoiceService.getInvoicesByCompany(id);

				return response;
			} catch (e) {
				console.log(e);
			}
		},
		async createInvoice({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await BillingInvoiceService.createInvoice(payload);

				return response.data.attributes;
			} catch (e) {
				console.log(e);
			}
		}
	},

	mutations: {}
};
